var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPinA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4945",
    d: "M8.23603 11.5782L11.689 15.004C11.689 15.004 10.9262 12.335 14.2992 8.98858C17.6721 5.64218 18.6022 5.56585 18.6022 5.56585L16.4531 3.42578",
    stroke: "#825DFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4946",
    d: "M8.23552 11.5787L4.78253 8.15287C4.78253 8.15287 7.47271 8.90967 10.8457 5.56328C14.2186 2.21689 14.3636 1.35268 14.3636 1.35268L16.4529 3.42601",
    stroke: "#825DFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 45",
    d: "M8.23633 11.5791L3.77921 16.0011",
    stroke: "#825DFC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPinA);
export default __webpack_public_path__ + "static/media/Icon_pin_a.3eda235b290652222136813b5116e043.svg";
export { ForwardRef as ReactComponent };